import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function HiddenIcon(props: SvgIconProps) {
  const st1: CSSProperties = {
    fill: "none",
    stroke: "currentcolor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 72 72">
      <g>
        <g>
          <path
            style={st1}
            d="M2,38.5c1.9,3.9,4.6,7.4,7.9,10.3,3.3,2.9,7.3,5.3,11.8,6.9,4.4,1.6,9.3,2.5,14.4,2.5s10-.9,14.4-2.5c4.4-1.6,8.4-4,11.8-6.9,3.3-2.9,6.1-6.4,7.9-10.3"
          />
          <path
            style={st1}
            d="M70.1,38.3c-1.9-3.9-4.6-7.4-7.9-10.3s-7.3-5.3-11.8-6.9c-4.4-1.6-9.3-2.5-14.4-2.5s-10,.9-14.4,2.5c-4.4,1.6-8.4,4-11.8,6.9-3.3,2.9-6.1,6.4-7.9,10.3"
          />
        </g>
        <circle style={st1} cx="36" cy="38.4" r="11.6" />
        <line style={st1} x1="62.5" y1="10.3" x2="9.5" y2="63.2" />
      </g>
    </SvgIcon>
  );
}
